import { inferVerticalCategoryFromGraph, } from "./resolve-vertical-category.js";
const DEFAULT_INDUSTRY_PACK_VERSION = "1.0.0";
const DEFAULT_DESIGN_PACK_VERSION = "1.0.0";
const STRATEGY_BY_DESIGN = {
    "design-hvac-emergency": "strategy-emergency-calls",
    "design-electrical-tech": "strategy-emergency-calls",
    "design-clean": "strategy-emergency-calls",
    "design-plumbing-utility": "strategy-local-trust",
    "design-roofing-earth": "strategy-local-trust",
    "design-landscaping-outdoor": "strategy-local-trust",
    "design-cleaning-minimal": "strategy-local-trust",
    "design-pest-warning": "strategy-local-trust",
    "design-premium-trust": "strategy-premium-lead",
};
const VERTICAL_PACK_SELECTION = {
    hvac: { industryPackId: "industry-hvac", designPackId: "design-hvac-emergency" },
    plumbing: { industryPackId: "industry-plumbing", designPackId: "design-plumbing-utility" },
    roofing: { industryPackId: "industry-roofing", designPackId: "design-roofing-earth" },
    landscaping: { industryPackId: "industry-landscaping", designPackId: "design-landscaping-outdoor" },
    cleaning: { industryPackId: "industry-cleaning", designPackId: "design-cleaning-minimal" },
    electrical: { industryPackId: "industry-electrical", designPackId: "design-electrical-tech" },
    "pest-control": { industryPackId: "industry-pest-control", designPackId: "design-pest-warning" },
    "premium-contractor": {
        industryPackId: "industry-premium-contractor",
        designPackId: "design-premium-trust",
    },
    fitness: { industryPackId: "industry-fitness", designPackId: "design-premium-trust" },
    "real-estate": { industryPackId: "industry-real-estate", designPackId: "design-premium-trust" },
    restaurant: { industryPackId: "industry-restaurant", designPackId: "design-cleaning-minimal" },
    dental: { industryPackId: "industry-dental", designPackId: "design-premium-trust" },
    ecommerce: { industryPackId: "industry-ecommerce", designPackId: "design-premium-trust" },
    nonprofit: { industryPackId: "industry-nonprofit", designPackId: "design-premium-trust" },
    unknown: { industryPackId: "industry-premium-contractor", designPackId: "design-premium-trust" },
};
export function resolveStrategyIdFromDesignPackId(designPackId) {
    return STRATEGY_BY_DESIGN[designPackId] ?? "strategy-emergency-calls";
}
export function resolvePackSelectionForGraph(graph) {
    const verticalCategory = inferVerticalCategoryFromGraph(graph);
    const selection = VERTICAL_PACK_SELECTION[verticalCategory];
    const strategyId = resolveStrategyIdFromDesignPackId(selection.designPackId);
    return {
        verticalCategory,
        industryPackId: selection.industryPackId,
        industryPackVersion: DEFAULT_INDUSTRY_PACK_VERSION,
        designPackId: selection.designPackId,
        designPackVersion: DEFAULT_DESIGN_PACK_VERSION,
        strategyId,
        packPin: {
            recipeId: "",
            industryPackId: selection.industryPackId,
            industryPackVersion: DEFAULT_INDUSTRY_PACK_VERSION,
            designPackId: selection.designPackId,
            designPackVersion: DEFAULT_DESIGN_PACK_VERSION,
            surfacePackId: "surface-website",
            surfacePackVersion: "1.0.0",
            packResolverTimestamp: "",
        },
    };
}
export function resolvePackPinFromGraph(graph, recipeId, packResolverTimestamp = new Date().toISOString()) {
    const resolved = resolvePackSelectionForGraph(graph);
    return {
        ...resolved.packPin,
        recipeId,
        packResolverTimestamp,
    };
}
export function resolveStrategyIdForGraph(graph) {
    return resolvePackSelectionForGraph(graph).strategyId;
}
//# sourceMappingURL=resolve-pack-pin-from-graph.js.map